// test550
(550 && 0);
